import { render } from "./UserCreateFields.vue?vue&type=template&id=f6d75e24&ts=true"
import script from "./UserCreateFields.vue?vue&type=script&lang=ts"
export * from "./UserCreateFields.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__